/**
 * Central configuration file
 * This provides a single source of truth for configuration values
 */

// API configuration
export const API_CONFIG = {
  // Use environment variable if available, otherwise fallback based on environment
  BASE_URL: process.env.REACT_APP_API_URL ||
    (process.env.NODE_ENV === 'production'
      ? window.location.origin.replace(':3000', ':4000') // Production: same host, port 4000
      : 'http://localhost:4000'), // Development: localhost
};

// Export individual commonly used values for convenience
export const API_BASE_URL = API_CONFIG.BASE_URL;

// Logging control - disable in production
export const ENABLE_DEBUG_LOGGING = process.env.NODE_ENV !== 'production'; 